export { TrustBadge } from './TrustModule.style';
export * from './TrustModule';
export * from './ContentfulTrustModule';
